<section
  class="layout__main-modal signature-pad"
  #signatureModal
>
  <div class="main__modal-header">
    <button
      class="close"
      mat-icon-button
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
    <h3 class="modal-heading">Add Signature</h3>
  </div>
  <mat-tab-group
    [selectedIndex]="selectedTabIndex"
    (selectedTabChange)="changeTab($event)"
  >
    <!-- <mat-tab [disabled]="!signingTypes.includes('drawSignature')">
            <ng-template matTabLabel>
                <div class="tab-title">
                    {{'Draw Signature' | uppercase}}
                </div>
            </ng-template>
            <ng-template matTabContent>
                <mat-dialog-content class="dialog-content">
                    <mat-slider color="primary" #mdSlider class="signature-pad-thickness" max="10" min="1" step="1" thumbLabel
                                tickInterval="1" [value]="3" [vertical]="true"
                                matTooltip="Change the thickness of signature" matTooltipPosition="right"
                                (change)="onChangeSignatureThickness($event)">
                    </mat-slider>
                    <button class="eraser-btn" mat-icon-button (click)="onRemoveSignature()">
                        <mat-icon svgIcon="erase"></mat-icon>
                    </button>
                    <div class="signature-pad-main">
                        <signature-pad #signaturePad [options]="signaturePadOptions" (window:resize)="resizeSignaturePad()"
                                       (onEndEvent)="drawComplete()" (onBeginEvent)="draw()">
                        </signature-pad>
                    </div>
                    <div class="draw-bottom-border">
                        <div class="draw-bottom-border-title">Draw above this line</div>
                    </div>
                </mat-dialog-content>
                <mat-dialog-actions class="dialog-actions">
                    <button class="w-2/5" mat-flat-button color="primary" (click)="submit()" [disabled]="!isSigned">
                        Add my Signature
                    </button>
                </mat-dialog-actions>
            </ng-template>
        </mat-tab> -->
    <mat-tab
      [disabled]="!signingTypes.includes('singpass')"
      (click)="prepareSingpass()"
    >
      <ng-template matTabLabel>
        {{ 'Sign with Singpass' | uppercase }}
      </ng-template>
      <ng-template matTabContent>
        <div class="singpass-main-content flex">
          <div class="instruction-wrapper w-1/2">
            <div class="instruction-title">Scan this QR Code to sign this document with Singpass Mobile App</div>
            <div class="instruction">INSTRUCTION</div>
            <div class="instruction-row">
              <div class="dash-line"></div>
              <div class="step-number">1</div>
              <div class="step-info">Open SingPass Mobile App and tap SCAN tab</div>
            </div>
            <div class="instruction-row">
              <div class="dash-line"></div>
              <div class="step-number">2</div>
              <div class="step-info">
                Scan the on-screen QR Code. <br />
                Match the reference code with the document
              </div>
            </div>
            <div class="instruction-row">
              <div class="dash-line"></div>
              <div class="step-number">3</div>
              <div class="step-info">Confirm the signing</div>
            </div>
            <div class="instruction-row">
              <div class="step-number">4</div>
              <div class="step-info">Verify your identity to complete</div>
            </div>
          </div>
          <div class="qr-code-wrapper w-1/2">
            <ng-container *ngIf="!singpassError.init && !singpassError.other">
              <div class="qr-code-main">
                <div class="reference-code-desc">
                  Check the document reference <br />
                  code in your app before signing
                </div>
                <div class="reference-code flex gap-2">
                  <div
                    #code
                    class="number"
                  >
                    -
                  </div>
                  <div
                    #code
                    class="number"
                  >
                    -
                  </div>
                  <div
                    #code
                    class="number"
                  >
                    -
                  </div>
                  <div
                    #code
                    class="number"
                  >
                    -
                  </div>
                </div>
                <div class="scan-app-desc">
                  Scan with Singpass app <br />
                  <span class="to-sign"> to sign document</span>
                </div>
                <div
                  class="singpass-qrcode"
                  #qrCodeRef
                >
                  <img
                    class="singpass-logo"
                    src="assets/core/singpass/singpass-logo.svg"
                  />
                  <ng-container *ngIf="singpassError.expired">
                    <div class="singpass-error">
                      <div class="error-message">Unable to generate Singpass QR Code</div>
                      <button
                        (click)="prepareSingpass()"
                        mat-flat-button
                        class="singpass-button"
                      >
                        <mat-icon>refresh</mat-icon>
                        Get New QR Code
                      </button>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="download-tip">
                Don't have Singpass app?
                <a
                  target="_blank"
                  href="https://app.singpass.gov.sg/"
                >
                  Download now</a
                >
              </div>
            </ng-container>
            <ng-container *ngIf="singpassError.init">
              <div class="singpass-error">
                <div class="error-message">Unable to generate Singpass QR Code</div>
                <button
                  (click)="prepareSingpass()"
                  mat-flat-button
                  class="singpass-button"
                >
                  <mat-icon>refresh</mat-icon>
                  Get New QR Code
                </button>
              </div>
            </ng-container>
            <ng-container *ngIf="singpassError.other">
              <div class="singpass-error">
                <div class="error-message">
                  Something went wrong <br />
                  <div class="error-text">Please try again or contact admin</div>
                </div>
                <button
                  (click)="prepareSingpass()"
                  mat-flat-button
                  class="singpass-button"
                >
                  <mat-icon>refresh</mat-icon>
                  Get New QR Code
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</section>
